export const FREE_LIBRARIES = new Set(["basicShapes", "connectors", "flowchart", "bpmn"]);
